__webpack_require__.p = "/animated-counter/";